export default __webpack_public_path__ + "static/media/btn-reime.11244df3.png";